import { useCallback, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

interface Option {
  value: string;
  label: string;
}

export const useMyServiceTypeOptions = () => {
  const { token } = useSelector((state: any) => state?.authReducer);
  const [limit, setLimit] = useState(200);
  const [myServiceTypeOptions, setMyServiceTypeOptions] = useState<{
    loading: boolean;
    list: Option[];
  }>({
    loading: false,
    list: [],
  });
 
  const getMyServiceTypeOptions = useCallback(async () => {
    setMyServiceTypeOptions({ loading: true, list: [] });

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/merchant/my-all-service-types?limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const mappedOptions = res?.data?.types?.map((serviceType: any) => ({
        value: serviceType?.type,
        label: serviceType?.name.replace("_", " "),
      }));

      setMyServiceTypeOptions({
        loading: false,
        list: mappedOptions || [],
      });
    } catch (error) {
      console.error("Failed to fetch service types", error);
      setMyServiceTypeOptions({ loading: false, list: [] });
    }
  }, [limit,token]);

  return {
    myServiceTypeOptions,
    getMyServiceTypeOptions,
  };
};